import React from 'react';
import { withJsonFormsControlProps } from '@jsonforms/react';
import EmptyBox from '../components/EmptyBox';
import { inputProps } from '../interface/inputfieldProps';




const ControlEmptyBox = (props: inputProps) => {
  return(
<EmptyBox 
    {...props}
/>
)};

export default withJsonFormsControlProps(ControlEmptyBox);